'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var applyDefaultOptions = require('./utils/apply-default-options');

var toSources = require('./utils/to-sources');

var cp = require('./cp');

var rm = require('./rm');

var defaultOptions = {
  parents: false,
  recursive: false,
  flush: true,
  cidVersion: 0,
  hashAlg: 'sha2-256',
  shardSplitThreshold: 1000
};

module.exports = function (context) {
  return /*#__PURE__*/function () {
    var _mfsMv = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _len,
          args,
          _key,
          _yield$toSources,
          sources,
          options,
          cpArgs,
          rmArgs,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = _args[_key];
              }

              if (Array.isArray(args[0])) {
                args = args[0].concat(args.slice(1));
              }

              _context.next = 4;
              return toSources(context, args);

            case 4:
              _yield$toSources = _context.sent;
              sources = _yield$toSources.sources;
              options = applyDefaultOptions(args, defaultOptions);
              cpArgs = sources.map(function (source) {
                return source.path;
              }).concat(options); // remove the last source as it'll be the destination

              rmArgs = sources.slice(0, -1).map(function (source) {
                return source.path;
              }).concat(Object.assign(options, {
                recursive: true
              }));
              _context.next = 11;
              return cp(context).apply(null, cpArgs);

            case 11:
              _context.next = 13;
              return rm(context).apply(null, rmArgs);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function mfsMv() {
      return _mfsMv.apply(this, arguments);
    }

    return mfsMv;
  }();
};